import PlusCircleSVG from "@design-system/ui-icons/vanilla/PlusCircle"
import { createIcon } from "../createIcon"

export const PlusCircleIcon = createIcon(PlusCircleSVG)
